module.exports = __webpack_public_path__ + "static/media/temperature.8ced7e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/temperature.png
// module id = 1482
// module chunks = 31